export var Type;
(function (Type) {
    Type["Default"] = "default";
    Type["Recommendation"] = "recommendation";
    Type["Highlight"] = "highlight";
    Type["Media"] = "media";
})(Type || (Type = {}));
//# sourceMappingURL=CsTag.js.map